'use client'

import { v4 as uuidv4 } from 'uuid'
import { Dispatch } from 'redux'
import { savePoint } from '../_store/common/common.slice'
import { IPoint } from '../_store/common/types'
import { yandexService } from '../_service/yandex.service'

/**
 * Handler for geolocation errors
 */
const errorHandler = (err: GeolocationPositionError) => {
  if (err.code === 1) {
    console.log('Error: Access is denied!')
  } else if (err.code === 2) {
    console.log('Error: Position is unavailable!')
  } else {
    console.log(`Error(${err.code}): ${err.message}`)
  }
}

type LocationData = {
  latitude: number
  longitude: number
}

const promise = async (): Promise<LocationData> => {
  const tg = window.Telegram?.WebApp

  return new Promise((resolve, reject) => {
    console.log('entering to promise')
    tg.LocationManager.getLocation(
      (location: { latitude: number; longitude: number } | null) => {
        if (location) {
          resolve({
            latitude: location.latitude,
            longitude: location.longitude,
          })
        } else {
          console.log('not okay')
          reject(new Error('Telegram location access denied or failed'))
        }
      }
    )
  })
}

export async function getUserLocation(): Promise<LocationData | null> {
  const tg = window.Telegram?.WebApp
  console.log('starting...', tg?.LocationManager)

  // Check if Telegram's geolocation is available
  if (
    tg &&
    tg?.LocationManager &&
    tg.LocationManager?.isInited &&
    ((tg.LocationManager?.isAccessRequested &&
      tg.LocationManager?.isAccessGranted) ||
      !tg.LocationManager?.isAccessRequested)
  ) {
    try {
      return promise()
    } catch (error) {
      console.log('LocationManager', error)
    }
  } else {
    console.log('this is else')
  }
  console.log('out of LocationManager')

  // Fallback to browser geolocation
  if ('geolocation' in navigator) {
    console.log('went to navigator')
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log('resolved navigator', position)
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          })
        },
        (error) => {
          console.log('unresolved navigator', error)
          errorHandler(error)
          reject(error)
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      )
    })
  }

  throw new Error('Geolocation is not supported in this environment.')
}

/**
 * Create a new point from coordinates using Yandex geocoding
 */
export const createPointFromCoordinates = async (
  geoloc: [number, number],
  dispatch: Dispatch<any>
): Promise<void> => {
  try {
    const res = await yandexService.getGeocode({
      geocode: geoloc.join(','),
      lang: 'ru_RU',
    })

    const newPoint: IPoint = {
      id: uuidv4(),
      location: geoloc,
      address:
        res?.data?.response?.response?.GeoObjectCollection?.featureMember?.[0]
          ?.GeoObject?.name,
      isActive: true,
      city: '',
      name: '',
    }

    dispatch(savePoint(newPoint))
  } catch (err) {
    console.log(err)
  }
}
export const createPointFromCoordinatesHomePage = async (
  geoloc: [number, number]
) => {
  try {
    const res = await yandexService.getGeocode({
      geocode: geoloc.join(','),
      lang: 'ru_RU',
    })

    const address =
      res?.data?.response?.response?.GeoObjectCollection?.featureMember?.[0]
        ?.GeoObject?.name

    const newPoint: IPoint = {
      id: uuidv4(),
      location: geoloc,
      address,
      isActive: true,
      city: '',
      name: '',
    }

    return newPoint
  } catch (err) {
    console.error('Error creating point from coordinates:', err)
  }
}

/**
 * Check if a new point should be created based on current state
 */
export const shouldCreateNewPoint = (
  geoloc: [number, number],
  points: IPoint[],
  activePoint: IPoint | null
): boolean => {
  return Boolean(
    geoloc?.[0] &&
      geoloc?.[1] &&
      !points?.length &&
      (!activePoint?.address ||
        (activePoint?.location?.[0] !== geoloc?.[0] &&
          activePoint?.location?.[1] !== geoloc?.[1]))
  )
}

/**
 * Find and set active point from points array
 */
export const findActivePoint = (points: IPoint[]) => {
  if (points?.length > 0) {
    for (const point of points) {
      if (point.isActive) return point
    }
  }

  return null
}
